const KEY_PREFIX = "bookingConfirmation-";

const storageKey = (reservationId) => `${KEY_PREFIX}${reservationId || "request"}`;

export const stashBookingConfirmation = ({ reservationId, email }) => {
  try {
    sessionStorage.setItem(storageKey(reservationId), JSON.stringify({ email }));
  } catch (_error) {
    // storage unavailable; the success page falls back to generic copy
  }
};

export const readBookingConfirmation = (reservationId) => {
  try {
    return JSON.parse(sessionStorage.getItem(storageKey(reservationId)) || "null");
  } catch (_error) {
    return null;
  }
};

